module.exports = __webpack_public_path__ + "img/OurJourney2019.0b91ac5e.png";